import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from "react-router-dom";
import TemplateDocumentEditor from "./TemplateDocumentEditor";
export var getTemplateDocumentEditorScene = function () { return (_jsx(Route, { path: "template-document/:templateDocumentId", element: _jsx(TemplateDocumentEditor, {}) })); };
